import { Shark, Utils } from "shark-mvc";

import "../../_shark_models/ConstructionSite";
import NotComplianceReport from "../../_shark_models/NotComplianceReport";
import ViewBase from "../ViewBase";


import templateContent from "./not-compliance-report-list.html";

import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import applicatorTeamManager from "../../_shark_jaws/managers/applicatorTeamManager";
import ccaDetailsManager from "../../controllers/ccaDetailsManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import closeNCRModalComponent from "../../components/closeNCRModal/closeNCRModalComponent";
import { communicationManager } from "../../_shark_jaws/managers/communicationManager";
import { constructionSiteMultiDateComponent } from "../../components/constructionSiteMultiDate/constructionSiteMultiDateComponent";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { notComplianceReportEditView } from "./notComplianceReportEditView";
import { notComplianceReportManager } from "../../_shark_jaws/managers/notComplianceReportManager";
import provinceFilterComponent from "../../_shark_components/provinceFilter/provinceFilterComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import setCCAModalComponent from "../../components/setCCAModal/setCCAModalComponent";
import setConstructionSiteWorksheetDocumentComponent from "../../components/setConstructionSiteWorksheetDocument/setConstructionSiteWorksheetDocumentComponent";
import teamUpManager from "../../_shark_jaws/managers/teamUpManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class NotComplianceReportListView extends ViewBase {
	constructor () {
		super("notComplianceReportListView");

		this.setTemplate(templateContent);
	}

	beforeLoad () {
		window.scroll(0, 0);

		constructionSiteMultiDateComponent.set("referenceListName", "notComplianceReportList");
		provinceFilterComponent.behavior = "database";
		// liveSearchComponent.behavior = "database";
		// liveSearchComponent.set({searchHint: "Il testo inserito verrà cercato nel nome del contatto, nel luogo di intervento, nella CCA."})
		followUpComponent.set("targetItem", null);

		if (Shark.get("clientList").length === 0) {
			clientManager.getListByAgent(Shark.get("currUser"));
		}
		
		if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
			applicatorTeamManager.getList()
			.then(() => {
				this.refreshList();
			});
		}
		else {
			this.refreshList();
		}

		this.set({
			__htmlTitle: "Rapporti di Non Conformità | IPM HUB",
		});

		exportCSVComponent.set({
			savedFileBaseName: "Lista Non Conformità",
			replaceMaps: {
				"considerAsUnderWarranty": {
					false: "No",
					true: "Sì",
				},
			},
			exportMap: {
				name: "Non Conformità",
				id: "notComplianceReportFieldMap",
				fields: {
					__numberLabel: "Numero",
					clientName: "Cliente",
					__siteLocationLabel: "Luogo Intervento",
					__agentName: "Agente",
					"extraData.quotationCCA": "CCA Preventivo",
					__lotIdLabel: "Lotto",
					__constructionSiteStartDateLabel: "Data inizio Cantiere originale",
					__constructionSiteEndDateLabel: "Data fine Cantiere originale",
					__csApplicatorTeam: "Squadra Cantiere originale",
					// Dave: qui ci vogliono i sistemi

					__notComplianceReferenceDateLabel: "Apertura Non Conformità",
					cca: "CCA Non Conformità",
					"ccaDetails.__timeSpanStartLabel": "Inizio Cantiere NC",
					"ccaDetails.__timeSpanEndLabel": "Fine Cantiere NC",
					__conclusionDateLabel: "Chiusura Non Conformità",
					"ccaDetails.__constructionApplicatorTeam": "Squadra NC",
					considerAsUnderWarranty: "Garanzia",
					__statusLabel: "Stato Non Conformità",

					__paymentStatusApplicatorTeamLabel: "Pagamento Squadra",
					__invoicingStatusCustomerLabel: "Fatturazione Cliente",
					__paymentStatusCustomerLabel: "Pagamento Cliente",
				},
			},
		});

	}

	beforeRender () {
		const notComplianceReportList = Shark.get("notComplianceReportList");

		followUpComponent.set({
			sourceList: notComplianceReportList
		});
	}

	init () {
		this.addComponents([agentFilterComponent, closeNCRModalComponent, constructionSiteMultiDateComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, liveSearchComponent, mainNavComponent, provinceFilterComponent, refreshListButtonComponent, setCCAModalComponent, setConstructionSiteWorksheetDocumentComponent, waitBoxComponent]);
		
		const filtersStatus = this.getFiltersStatus();

		const notComplianceReportActiveFilters = Shark.getInstance("__smart__", {
			showOpen: filtersStatus ? filtersStatus.showOpen : true,
			showWaitingCCAOrCSWS: filtersStatus ? filtersStatus.showWaitingCCAOrCSWS : true,
			showReadyForCS: filtersStatus ? filtersStatus.showReadyForCS : true,
			showCSRunning: filtersStatus ? filtersStatus.showCSRunning : true,
			showCompleted: filtersStatus ? filtersStatus.showCompleted : false,
			showEnded: filtersStatus ? filtersStatus.showEnded : false,
		});
	
		notComplianceReportActiveFilters.on("dataChanged", function () {
			notComplianceReportListView.saveFiltersStatus(this);

			waitBoxComponent.open();
			notComplianceReportListView.sortAndFilterList();
			exportCSVComponent.set({
				listToExport: Shark.get("notComplianceReportList").filter(item => item.__render),
			});
			setTimeout(() => {
				waitBoxComponent.close();
				Shark.render();
			}, 250);
		});
	
		Shark.set({
			clientList: Shark.get("clientList") || [],
			notComplianceReportActiveFilters,
			notComplianceReportList: Shark.get("notComplianceReportList") || []
		});
	}

	invoicingStatusBadge_clickHandler (event, data) {
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);
		const noteType = data.type || "";

		const noteTypeLabel = noteType === "Customer" ? " al Cliente" : " dalla Squadra";

		if (currNotComplianceReport && currNotComplianceReport[`invoicingNote${noteType}`]) {
			informationModalComponent.show({body: currNotComplianceReport[`invoicingNote${noteType}`].replace(/\n/g, "<br>"), title: "Informazioni sulla fatturazione" + noteTypeLabel});
		}
	}

	paymentStatusBadge_clickHandler (event, data) {
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);
		const noteType = data.type || "";

		const noteTypeLabel = noteType === "Customer" ? " del Cliente" : " della Squadra";

		if (currNotComplianceReport && currNotComplianceReport[`paymentNote${noteType}`]) {
			informationModalComponent.show({body: currNotComplianceReport[`paymentNote${noteType}`].replace(/\n/g, "<br>"), title: "Informazioni sul pagamento" + noteTypeLabel});
		}
	}

	refreshList (range = null, force = false) {
		waitBoxComponent.open();
		const currConstructionSite = Shark.get("currConstructionSite");
	
		//Dave: occhio che se vengo dalla lista dei cantieri questo fa casino, metto una pezza nel MainNavigation, ma non dovrebbe stare li
		if (currConstructionSite) {
			notComplianceReportManager.getListByConstructionSite(currConstructionSite)
			.then(() => {
				exportCSVComponent.set({
					listToExport: Shark.get("notComplianceReportList"),
				});

				waitBoxComponent.close();
				Shark.render();//Sarebbe bello lo facesse da se, ma se la lista non cambia hash, non va...
			});
		}
		else {
			// Dave: Qui serve il getFilteredList
			notComplianceReportManager.getList()
			.then(getListResponse => {

				const provinceForFilterComponentSet = new Set();
				getListResponse.data.forEach(item => provinceForFilterComponentSet.add(item.siteLocation.province));
		
				//Dave: Spostalo nel componente
				let provinceForFilterComponent = Array.from(provinceForFilterComponentSet);
				provinceForFilterComponent.sort();
				provinceForFilterComponent = provinceForFilterComponent.map(item => item.trim() !== "" ? {label: item, value: item} : {label: "- Non impostata", value: ""});
		
				Shark.set({provinceForFilterComponent});

				this.sortAndFilterList();
				exportCSVComponent.set({
					listToExport: Shark.get("notComplianceReportList").filter(item => item.__render),
				});

				waitBoxComponent.close();
				Shark.render();//Sarebbe bello lo facesse da se, ma se la lista non cambia hash, non va...
			});
		}
	}

	setAsReadyForConstructionSiteBtn_clickHandler (event, data) {
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);

		if (currNotComplianceReport && confirm("Vuoi davvero promuovere questa Non Conformità e renderla idonea per far partire il Cantiere?\nSe confermi partirà l'iter per l'assegnazione di CCA e Foglio Lavoro Cantiere, e non potrai annullare l'operazione.")) {
			waitBoxComponent.open();

			currNotComplianceReport.set({
				status: 4,
			});

			notComplianceReportManager.save(currNotComplianceReport)
			.then(response => {
				console.log({response});

				communicationManager.notComplianceReportSetAsReadyForCSIPM(currNotComplianceReport)
				.then(() => {
					waitBoxComponent.hide();

					if (typeof Shark.activePage.refreshList === "function") {
						Shark.activePage.refreshList();
					}
					else {
						Shark.render();
					}
				});
			});
		}
	}
	
	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}
	
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);
	
		if (currNotComplianceReport) {
			Shark.set({currNotComplianceReport});
			followUpComponent.set("targetItem", currNotComplianceReport);
			notComplianceReportEditView.set({
				afterSaveDestination: notComplianceReportListView,
				cancelDestination: notComplianceReportListView
			});
	
			Shark.openPage(notComplianceReportEditView);
		}
	}
	
	sortAndFilterList () {
		let notComplianceReportList = Shark.get("notComplianceReportList");
	
		if (notComplianceReportList) {
			const [agentFilter, notComplianceReportActiveFilters, dateRangeFilter, provinceFilter] = Shark.get(["agentFilter", "notComplianceReportActiveFilters", "dateRangeFilter", "provinceFilter"]);
			let counter = 0;

			notComplianceReportList.forEach((item) => {
				// let count = false;

				if (!dateRangeFilter.ignoreDateRange && !dateRangeFilterComponent.includeDate(item.__reportDate) && !dateRangeFilterComponent.includeDate(item.__updatedAt)) {
					item.__render = false;
				}
				else {
					item.__render = [NotComplianceReport.STATUS_OPEN].indexOf(item.status) > -1  && notComplianceReportActiveFilters.showOpen ||
					[NotComplianceReport.STATUS_WAITING_CS_DETAILS].indexOf(item.status) > -1 && notComplianceReportActiveFilters.showWaitingCCAOrCSWS ||
					item.status === NotComplianceReport.STATUS_CS_READY_TO_START && notComplianceReportActiveFilters.showReadyForCS ||
					[NotComplianceReport.STATUS_CS_RUNNING].indexOf(item.status) > -1 && notComplianceReportActiveFilters.showCSRunning ||
					// [NotComplianceReport.STATUS_CLOSED].indexOf(item.status) > -1 && notComplianceReportActiveFilters.showCompleted ||
					item.status === NotComplianceReport.STATUS_CLOSED && notComplianceReportActiveFilters.showEnded
					;
					// item.__render = true;
				}

				if (item.__render && agentFilter.agentGuid !== "" && item.userGuid !== agentFilter.agentGuid) {
					item.__render = false;
				}

				if (item.__render && provinceFilter.province !== "all" && provinceFilter.province !== item.siteLocation.province) {
					item.__render = false;
				}

				if (item.__render) {
					item.__displayIndex = counter + 1;
					counter++;
				}
			});

			Shark.set({
				__showNoFiltersMatch: counter === 0,
			});
		}
	}

	updateDateBtn_clickHandler (event, data) {
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);

		if (currNotComplianceReport) {
			const cca = currNotComplianceReport.cca.trim();
			// console.log({cca, currNotComplianceReport});

			if (cca !== "") {
				event.target.classList.add("loading");

				//DAve: Ovviamente tutta questa operazione dovrebbe essere inserita lato API, così la posso fare sia da qui che da CRON.
				teamUpManager.getEventListByCCA(cca, currNotComplianceReport.__teamUpId)
				.then(response => {
					console.log({response});
					const ccaNewData = response.currCCADetails;

					ccaDetailsManager.getByGuid(currNotComplianceReport.ccaDetailsGuid)
					.then(getByGuidResponse => {
						console.log({getByGuidResponse});
						console.log(getByGuidResponse.data.export());
						const ccaDetails = getByGuidResponse.data;
						const ccaDetailsUpdated = (ccaDetails.applicatorTeamGuid !== ccaNewData.applicatorTeamGuid ||
							ccaDetails.cca !== ccaNewData.cca ||
							ccaDetails.note !== ccaNewData.note ||
							ccaDetails.__timeSpanEnd !== ccaNewData.__timeSpanEnd ||
							ccaDetails.__timeSpanStart !== ccaNewData.__timeSpanStart);

						const oldHash = ccaDetails.timeRanges.map(item => Utils.computeHash(item));
						const newHash = ccaNewData.timeRanges.map(item => Utils.computeHash(item));
						const timeRangesUpdated = oldHash.join() !== newHash.join();

						ccaDetails.set({
							applicatorTeamGuid: ccaNewData.applicatorTeamGuid,
							cca: ccaNewData.cca,
							note: ccaNewData.note,
							timeRanges: ccaNewData.timeRanges,
							timeSpanEnd: ccaNewData.timeSpanEnd,
							timeSpanStart: ccaNewData.timeSpanStart,
						});
						console.log({ccaDetails, ccaDetailsUpdated, timeRangesUpdated, oldHash, newHash, arr1: Utils.computeHash(ccaDetails.timeRanges), arr2: Utils.computeHash(ccaNewData.timeRanges)});
						
						if (ccaDetailsUpdated || timeRangesUpdated) {
							ccaDetailsManager.save(ccaDetails)
							.then(saveResponse => {
								console.log({saveResponse});
								
								event.target.classList.remove("loading");
								currNotComplianceReport.ccaDetails = ccaDetails;
								Shark.render();

								const newFollowUp = Shark.getInstance("ClientFollowUp", {
									body: `Le date di riferimento della CCA sono state aggiornate da TeamUp.`,
									clientGuid: currNotComplianceReport.clientGuid,
									referenceGuid: currNotComplianceReport.guid,
									referenceType: "notComplianceReport",
									status: 3,
									type: "system"
								});
						
								followUpManager.save(newFollowUp);
							});
						}
						else {
							event.target.classList.remove("loading");
						}
					});
				});
			}
		}
	}
}

const notComplianceReportListView = new NotComplianceReportListView();

Shark.registerView(notComplianceReportListView);

export { notComplianceReportListView };
